import React from 'react';

// Bold, flat SVG mango with black outline — block style
export default function MangoIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 220 220" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <ellipse cx="110" cy="118" rx="82" ry="70" fill="#FF7A1A" stroke="#1B1A17" strokeWidth="5" />
      <ellipse cx="86" cy="96" rx="40" ry="22" fill="#FFD24A" opacity="0.85" />
      <path d="M120 48 c8 -6 22 -8 32 -2 -4 8 -16 14 -28 14 z" fill="#2E8B57" stroke="#1B1A17" strokeWidth="4" strokeLinejoin="round" />
      <path d="M122 52 c4 -2 10 -2 14 0 -2 4 -8 6 -14 4 z" fill="#246b43" />
    </svg>
  );
}
